import { render, staticRenderFns } from "./DoubleSlider.vue?vue&type=template&id=0b756b3e&"
import script from "./DoubleSlider.vue?vue&type=script&lang=js&"
export * from "./DoubleSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports